import {faTrash} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'antd';
import {useEffect, useState} from 'react';

import {Text} from '../../component/text/text';
import {Locale} from '../../provider/locale/locale';
import {LangKeyType} from '../../provider/locale/translation/type';
import {classNames} from '../../util/css';

import * as styles from './company-popup-v2.scss';

type PropsType = {
    className?: string;
    selectorId: string;
    selectedCount: number;
    onClear: () => void;
    onReady?: () => void;
    disabled?: boolean;
    hideSubmitButton?: boolean;
    // The reworked layout (stories form) shows the total company count here, because the selected
    // count has moved up into the header.
    totalCount?: number;
    submitLangKey?: LangKeyType;
    isSubmitDisabled?: boolean;
    isSubmitLoading?: boolean;
};

export function CompanySelectModalFooter(props: PropsType): JSX.Element {
    const {
        selectedCount,
        onClear,
        onReady,
        disabled,
        hideSubmitButton,
        className,
        selectorId,
        totalCount,
        submitLangKey = 'BUTTON__FINISH',
        isSubmitDisabled,
        isSubmitLoading,
    } = props;

    const [counterAnimationClassName, setCounterAnimationClassName] = useState<string | null>(null);

    useEffect(() => {
        if (selectorId && selectedCount) {
            setCounterAnimationClassName(styles.CompaniesSelectModal_selectedCount__animateNotEmpty);
        }
    }, [selectedCount, selectorId]);

    useEffect(() => {
        const timeoutId = setTimeout(() => setCounterAnimationClassName(null), 300);

        return () => clearTimeout(timeoutId);
    }, [counterAnimationClassName]);

    function renderCount(): JSX.Element {
        if (typeof totalCount === 'number') {
            return <Locale stringKey="COMPANY__MULTISELECT__TOTAL_COUNT" valueMap={{count: totalCount}} />;
        }

        if (selectedCount) {
            return <Locale stringKey="COMPANY__MULTISELECT__SELECTED_COUNT" valueMap={{count: selectedCount}} />;
        }

        return <Locale stringKey="COMPANY__MULTISELECT__NO_COMPANIES_SELECTED" />;
    }

    return (
        <div className={classNames(styles.CompaniesSelectModal_footer, className)}>
            <div
                className={classNames(
                    styles.CompaniesSelectModal_selectedCount,
                    {
                        [styles.CompaniesSelectModal_selectedCount__empty]: !selectedCount,
                    },
                    counterAnimationClassName
                )}
            >
                <Text block inheritColor>
                    {renderCount()}
                </Text>
            </div>
            <Button
                disabled={disabled || !selectedCount}
                icon={<FontAwesomeIcon icon={faTrash} />}
                onClick={onClear}
                type="default"
            >
                <Text inheritColor>
                    <Locale stringKey="COMPANY__MULTISELECT__CLEAR_SELECTION" />
                </Text>
            </Button>
            {!hideSubmitButton && onReady && (
                <Button disabled={isSubmitDisabled} loading={isSubmitLoading} onClick={onReady} type="primary">
                    <Locale stringKey={submitLangKey} />
                </Button>
            )}
        </div>
    );
}
